// extracted by mini-css-extract-plugin
export default {"statusContainer":"JWjyMa6BmZM_4ebEIDA7"};